import React from 'react'
import PropTypes from 'prop-types'
import { Copy, Box, Icon } from '@elparking/components'

const Field = ({label, icon, value, color}) => (
    <Box py='0.5em'>
        <Copy fontWeight='book' fontSize='xxxSmall' color='gray60' transform='uppercase' padding='0 0 0.2em 0'>
            {label}
        </Copy>
        <Box background='lightGray20' p='0.8em'>
            <Copy fontSize='xxSmall' lines='1' overflow='hidden' boxOrient='vertical' display='-webkit-box' fontWeight='book' padding='0' fontColor={color}>
                {icon && <Icon size='medium' color='gray' type={icon} />} { value }
            </Copy>
        </Box>
    </Box>
)

Field.propTypes = {
    label: PropTypes.node.isRequired,
    value: PropTypes.node.isRequired,
    icon: PropTypes.string,
    color: PropTypes.string.isRequired,
}

Field.defaultProps = {
    color: 'gray',
}

export default Field
